import styled from 'styled-components/macro';

export const TableWrapper = styled.div`
  max-width: 1262px;
  width: 100%;
`;

export const Wrapper = styled.div``;
